import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { BaseResizableComponent } from '@src/app/modules/base';
import { AuthUserService } from '@src/app/modules/auth';

import { LpDiscountDialogService } from '../../../services';
import { LoyaltyProgramProductWithExternalUnionId } from '../../../models/LoyaltyProgramProduct';

@Component({
  selector: 'lp-view-discount-groups-dialog',
  templateUrl: './discount-groups-dialog.component.html',
  styleUrls: ['./discount-groups-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscountGroupsDialogComponent extends BaseResizableComponent {
  private readonly lpDiscountDialogService = inject(LpDiscountDialogService);
  private readonly authUserService = inject(AuthUserService);
  private readonly context = injectContext<TuiDialogContext<void, LoyaltyProgramProductWithExternalUnionId>>();

  private discountDialogOpen = false;

  get product() {
    return this.context.data.product;
  }

  get externalUnionId() {
    return this.context.data.externalUnionId;
  }

  get isUserOrganisation() {
    return this.product?.contacts.company.id === this.authUserService.user?.organisationId;
  }

  get isUserAssociation() {
    return this.product?.contacts.company.parentOrganisationId === this.authUserService.user?.parentOrganisationId;
  }

  getDiscount(discountGroupId?: string) {
    if (this.discountDialogOpen) return;

    this.discountDialogOpen = true;

    this.lpDiscountDialogService
      .openDiscountDialogWithRequest(this.product, this.externalUnionId, discountGroupId)
      .subscribe({
        error: () => {
          this.discountDialogOpen = false;
        },
        complete: () => {
          this.discountDialogOpen = false;
        },
      });
  }
}
